import { createAsyncThunk } from "@reduxjs/toolkit";
import { UpdateUser, UpdateUserParams } from "../../domain/usecases/updateUser";
import {
	CheckSignupPhotoLiveness,
	CheckSignupPhotoLivenessParams,
} from "../../domain/usecases/checkSignupPhotoLiveness";
import {
	SaveSignupPhotoLivenessResult,
	SaveSignupPhotoLivenessResultParams,
} from "../../domain/usecases/saveSignupPhotoLivenessResult";
import {
	SendProfileConfig,
	SendProfileConfigParams,
} from "../../domain/usecases/sendProfileConfig";
import { GetCategories } from "../../domain/usecases/getCategories";
import { GetUser } from "../../domain/usecases/getUser";
import { GetProfileConfig } from "../../domain/usecases/getProfileConfig";
import { ListenPartnerInvited } from "../../../settings/domain/usecases/onPartnerInvited";
import { Partner } from "../../../settings/domain/entities/Partner";
import { SendNewTicket } from "../../domain/usecases/sendNewTicket";
import { UserTicket } from "../../domain/entities/userTicket";
import { GetReferralCode } from "../../domain/usecases/getReferralCode";
import { setCurrentRadio } from "../../../match/presentation/store/MatchSlice";
import { setPartner } from "./OnboardingSlice";
import { deletePartnerFromList } from "../../../settings/presentation/store/PartnerSlice";

export const onCheckSignupPhotoLiveness = createAsyncThunk(
	"profile/signup-photo-liveness/check",
	async (params: CheckSignupPhotoLivenessParams, { extra }) => {
		const { checkSignupPhotoLiveness } = extra as {
			checkSignupPhotoLiveness: CheckSignupPhotoLiveness;
		};
		const result = await checkSignupPhotoLiveness.execute(params);
		return result;
	}
);

export const onSaveSignupPhotoLivenessResult = createAsyncThunk(
	"profile/signup-photo-liveness/result",
	async (params: SaveSignupPhotoLivenessResultParams, { extra }) => {
		const { saveSignupPhotoLivenessResult } = extra as {
			saveSignupPhotoLivenessResult: SaveSignupPhotoLivenessResult;
		};
		const result = await saveSignupPhotoLivenessResult.execute(params);
		return result;
	}
);


export const onGetUser = createAsyncThunk("auth/info", async (_, { extra }) => {
	const { getUser } = extra as { getUser: GetUser };
	const result = await getUser.execute();
	return result;
});

export const onUpdateUser = createAsyncThunk(
	"auth/update",
	async (params: UpdateUserParams, { extra }) => {
		const { updateUser } = extra as { updateUser: UpdateUser };
		const result = await updateUser.execute(params);
		return result;
	}
);

export const onGetCategories = createAsyncThunk(
	"profile/categories",
	async (_, { extra }) => {
		const { getCategories } = extra as { getCategories: GetCategories };
		const list = await Promise.all([
			getCategories.execute({ endpoint: "show-me" }),
			getCategories.execute({ endpoint: "desires" }),
			getCategories.execute({ endpoint: "sexual-orientations" }),
			getCategories.execute({ endpoint: "genders" }),
			getCategories.execute({ endpoint: "maritals-status" }),
		]);
		return list;
	}
);

export const onSendProfileConfig = createAsyncThunk(
	"profile/config",
	async (params: SendProfileConfigParams, { extra, dispatch }) => {
		const { sendProfileConfig } = extra as {
			sendProfileConfig: SendProfileConfig;
		};
		const result = await sendProfileConfig.execute(params);
		dispatch(setCurrentRadio(result.search_filters.max_distance));
		return result;
	}
);

export const onGetProfileConfig = createAsyncThunk(
	"auth/getconfig",
	async (_, { extra, dispatch }) => {
		const { getProfileConfig } = extra as {
			getProfileConfig: GetProfileConfig;
		};
		const result = await getProfileConfig.execute();
		dispatch(setCurrentRadio(result.search_filters.max_distance));
		return result;
	}
);

export const onGetReferralCode = createAsyncThunk(
	"auth/referral-code",
	async (_, { extra }) => {
		const { getReferralCode } = extra as {
			getReferralCode: GetReferralCode;
		};
		const result = await getReferralCode.execute();
		return result;
	}
);

export const onListenPartnerInvitation = createAsyncThunk(
	"partner/notification_partner_invited",
	async (_, { extra, dispatch }) => {
		const { listenPartnerInvited } = extra as {
			listenPartnerInvited: ListenPartnerInvited;
		};
		listenPartnerInvited.execute((partner: Partner) => {
			dispatch(setPartner(partner));
			dispatch(deletePartnerFromList({
                user_id: partner.user_id1,
				...partner
            }));
		});
	}
);

export const onSendNewTicket = createAsyncThunk(
	"profile/user-ticket",
	async (data: UserTicket, { extra }) => {
		const { sendNewTicket } = extra as { sendNewTicket: SendNewTicket };
		await sendNewTicket.execute(data);
		return;
	}
);
